import * as yup from "yup"
import { isValidPhone } from "../../../../utils/phone"

export const schema = yup.object().shape({
  email: yup.string().email().required(),
  phone: yup
    .string()
    .test("phoneCheck", "Phone number check", (value: string) =>
      isValidPhone(value, false)
    ),
})
